import { Sparkles } from "lucide-react";
import { TRUST } from "@/data";

export default function TrustBar() {
  const items = [...TRUST, ...TRUST];
  return (
    <section data-testid="trust-bar" className="bg-pd-forest py-5 overflow-hidden">
      <div className="pd-marquee relative">
        <div className="pd-marquee-track">
          {items.map((t, i) => (
            <div key={i} className="flex items-center gap-3 px-8 shrink-0">
              <Sparkles size={16} className="text-pd-accent" />
              <span className="font-display italic text-xl md:text-2xl text-pd-bg/90 whitespace-nowrap">
                {t}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
